var _linearGradient, _linearGradient2, _linearGradient3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: -1.15,
    x2: 47.15,
    y1: 44.44,
    y2: -4.52
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2481eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061a90"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 6.12,
    x2: 54.42,
    xlinkHref: "#linear-gradient",
    y1: 51.61,
    y2: 2.65
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2.39,
    x2: 50.68,
    xlinkHref: "#linear-gradient",
    y1: 47.92,
    y2: -1.03
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25 23.86a5.93 5.93 0 1 0 -5.93-5.93 5.94 5.94 0 0 0 5.93 5.93zm0-9.86a3.93 3.93 0 1 1 -3.93 3.93 3.93 3.93 0 0 1 3.93-3.93z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.47 25.14h-6.94a5.75 5.75 0 0 0 -5.74 5.75v5.11a1 1 0 0 0 1 1h16.42a1 1 0 0 0 1-1v-5.11a5.75 5.75 0 0 0 -5.74-5.75zm-6.58 2h6.22v7.86h-6.22zm-4.1 3.75a3.73 3.73 0 0 1 2.1-3.35v7.46h-2.1zm14.42 4.11h-2.1v-7.46a3.73 3.73 0 0 1 2.1 3.35z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 4a21 21 0 1 0 21 21 21 21 0 0 0 -21-21zm0 40a19 19 0 1 1 19-19 19 19 0 0 1 -19 19z",
    fill: "url(#linear-gradient-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.8c3043ee770c0c28b51540cdb16e3d84.svg";
export { ForwardRef as ReactComponent };